import React, {Fragment, useState} from "react";
import {Col, Form, Input, Row} from "antd";
import {FormattedMessage} from "react-intl";
import {Person} from "@models/person";
import PersonSelection from "@components/people/Selection";
import {SelectionMode} from '@models';

interface ArtistProps {
  selectedPerson: Person | null;
  form: any;
}

const WidgetItemPersonSelection: React.FC<ArtistProps> = props => {

  const {form, selectedPerson} = props;
  const [person, setPerson] = useState(selectedPerson || null);

  const onSelectPerson = (person: Person) => {
    setPerson(person)
    form.setFieldsValue({
      person: person,
      person_id: person.id,
    });
  };
  return (
    <Fragment>
      <Form.Item className={"no-label"}>
        {form.getFieldDecorator("person", {
          initialValue: person
        })(
          <Input type={`hidden`}/>
        )}
      </Form.Item>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item label={<FormattedMessage id="app.select_person" defaultMessage={`Select Person`}/>}>
            {form.getFieldDecorator("person_id", {
              initialValue: person ? person.id : null,
              rules: [
                {
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.person_is_required"
                      defaultMessage={`Select person!`}
                    />
                  )
                }
              ]
            })(<Input type={`hidden`}/>)}
            <PersonSelection mode={SelectionMode.DEFAULT} onChange={onSelectPerson}
                             selectedPerson={person}/>
          </Form.Item>
        </Col>
      </Row>
    </Fragment>
  )
};

export default WidgetItemPersonSelection;



